import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "12",
      fill: _ctx.fillColor
    }, null, 8, _hoisted_2),
    _cache[0] || (_cache[0] = _createElementVNode("path", {
      d: "M18.7062 7.29297C19.0968 7.68359 19.0968 8.31797 18.7062 8.70859L10.7062 16.7086C10.3155 17.0992 9.68115 17.0992 9.29053 16.7086L5.29053 12.7086C4.8999 12.318 4.8999 11.6836 5.29053 11.293C5.68115 10.9023 6.31553 10.9023 6.70615 11.293L9.9999 14.5836L17.2937 7.29297C17.6843 6.90234 18.3187 6.90234 18.7093 7.29297H18.7062Z",
      fill: "white"
    }, null, -1))
  ]))
}